import { goBack, lightImpactVibrate, onReady } from '../../utils/appBridge'
import { useQuery } from '@tanstack/react-query'
import { useSearchParams } from 'react-router-dom'
import { fetchTaxCalculations } from '../../repository/mfExecution'
import { useEffect, useMemo, useState } from 'react'
import { calculateTieredExitLoad } from '../../utils/mf-execution/withdrawUtils'
import { LoadingSpinner } from '../../components/LoadingSpinner'
import { TaxLiabilityBottomSheetContent } from '../../components/BottomSheetComponents/mf-execution/withdraw/TaxLiabilityBottomSheet'
import { getBottomPadding } from '../../utils/sessionStorage'

export const TaxLiabilityPage = () => {
  const [calculatedExitLoad, setCalculatedExitLoad] = useState(0)
  const [searchParams] = useSearchParams()
  const isin = useMemo(() => searchParams?.get('isin'), [searchParams]) || ''
  const folioNumber = useMemo(() => searchParams?.get('folioNumber'), [searchParams]) || ''
  const amount = useMemo(() => parseFloat(searchParams?.get('amount') || '0'), [searchParams])

  const {
    data: taxCalculations,
    isLoading: isTaxCalculationsLoading,
    isError: isTaxCalculationsError
  } = useQuery({
    queryKey: ['tax-calculations', folioNumber, isin],
    queryFn: () => fetchTaxCalculations({ folioNumber: folioNumber ?? '', isin: isin, amount: amount }),
    enabled: !!folioNumber && !!isin
  })

  useEffect(() => {
    if (taxCalculations) onReady()
  }, [taxCalculations])

  // Recalculate exit load when taxCalculations change
  useEffect(() => {
    if ((amount ?? 0) > 0 && taxCalculations?.exitLoadSlabs) {
      const exitLoad = calculateTieredExitLoad(amount, taxCalculations.exitLoadSlabs)
      setCalculatedExitLoad(exitLoad)
    }
  }, [taxCalculations?.exitLoadSlabs, amount])

  if (isTaxCalculationsLoading) return <LoadingSpinner />

  return (
    <div className='pt-6 pb-1 h-full w-full relative'>
      <div className='h-full pb-48 overflow-y-auto no-scrollbar'>
        <div className='text-[#232323] text-[22px] font-[400] pb-3 px-5'>Tax Liability</div>
        {isTaxCalculationsError ? (
          <div className='text-[#992617] text-[13px] font-[400] h-96 flex items-center justify-center px-5 border-t border-[#F0F4F7] bg-[#FBEFEF]'>
            Error fetching tax calculations.
          </div>
        ) : (
          <TaxLiabilityBottomSheetContent
            testLocator='MFE_ENTER_AMOUNT_BS_TAX_LIABILITY'
            withdrawalAmount={amount}
            exitLoad={calculatedExitLoad}
            stcgInfo={taxCalculations?.stcgTaxInfo ?? { gains: 0, investedAmount: 0, taxRate: 0, taxableAmount: 0 }}
            ltcgInfo={taxCalculations?.ltcgTaxInfo ?? { gains: 0, investedAmount: 0, taxRate: 0, taxableAmount: 0 }}
            grandfatheringRuleApplicable={taxCalculations?.grandfatheringRuleApplicable ?? false}
          />
        )}
      </div>
      <div className='sticky bottom-0 left-0 right-0'>
        <div
          style={{ paddingBottom: `${getBottomPadding() + 8}px` }}
          className='px-5 pt-1 bg-gradient-to-b from-[rgba(255,255,255,0)] via-[rgba(255,255,255,0.3)] to-[rgba(255,255,255,0.8)]'
        >
          <button
            onClick={() => {
              lightImpactVibrate()
              goBack()
            }}
            className='w-full py-2 px-4 bg-[#232323] text-white font-medium rounded-xl h-14 
        outline-none focus:outline-none'
          >
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
